{
    "warning": "BABALA!",
    "message": "Huwag maglagay o mag-paste ng code na hindi mo naiintindihan\nAng paggamit sa console na ito ay puwedeng magbigay-daan sa mga attacker na magpanggap bilang ikaw at nakawin ang iyong impormasyon gamit ang isang attack na tinatawag na Self-XSS."
}
